(function () {
	'use strict';

	angular
		.module('app.core')
		.directive('uiSelectParentScroll', uiSelectParentScroll);

	uiSelectParentScroll.$inject = [];

	function uiSelectParentScroll() {
		return {
			require: 'uiSelect',
			link: function (scope, element, attrs, $select) {
				scope.$on('closeAll', function(ev, val) {
					$select.close();
				});
			}
		};
	}
})();
